import { Env } from '../app/core/enums/env.enum';

export const environment = {
  type: Env.DEVELOPMENT,
  production: false,
  cognito: {
    REDIRECT_URI: 'https://users.dev.wilshire.com',
    REDIRECT_URI_SIGNOUT: 'https://users.dev.wilshire.com',
    USERPOOL_ID: 'us-west-2_gZNcJBSEo',
    APP_DOMAIN: 'account.dev.wilshire.com',
    CLIENT_ID: '1gfbo8n3lgfv1rf2m80n8eigqe',
    REGION: 'us-west-2',
  },
  cognitoGroupName: 'Users',
  apiEndpoint: 'https://usersapi.dev.wilshire.com/v1',
};
